import { render, staticRenderFns } from "./ToExchangeDetails.vue?vue&type=template&id=12034e34&scoped=true&"
import script from "./ToExchangeDetails.vue?vue&type=script&lang=js&"
export * from "./ToExchangeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ToExchangeDetails.vue?vue&type=style&index=0&id=12034e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12034e34",
  null
  
)

export default component.exports